<template>
    <div class="MentionsLegales">
        <HeadPageImage class="updateIconMentionsLegales"
                       :title="'Mentions légales'"
                       :subTitle="'Dernière mise à jour le 03/03/2023'"
                       :icon1="'legal/LegalDocument2.svg'" :altIcon1="'Decoration Document Legal'"
                       :icon2="'legal/LegalDocument1.svg'" :altIcon2="'Decoration Document Legal'"
                       :img1="'legal/happyWoman.jpg'" :altImg1="'Decoration happyWoman'"
                       :img2="'legal/legalHammer.jpg'" :altImg2="'Decoration legalHammer'"
                       :img3="'legal/contract.jpg'" :altImg3="'Decoration contract'"
                       :img4="'legal/lawyer.jpg'" :altImg4="'Decoration lawyer'"
        />
        <div class="MentionsLegales-Container-Text">
            <p>
                <span class="bold">Raison sociale :</span>
                <span>JobStream</span>
            </p>
            <p>
                <span class="bold">Forme juridique :</span>
                <span>SAS</span>
            </p>
            <p>
                <span class="bold">Siège social :</span>
                <span>230, rue Pierre Duhem - 13 290 Aix en Provence</span>
            </p>
            <p>
                <span class="bold">Capital social :</span>
                <span>10 000€</span>
            </p>
            <p>
                <span class="bold">Siret :</span>
                <span>824 696 322 00026 R.C.S Aix en Provence</span>
            </p>
            <p>
                <span class="bold">N° organisme de formation :</span>
                <span>93131904713</span>
            </p>
            <p>
                <span class="bold">Téléphone :</span>
                <span>
                    <a href="tel:0482325001">04 82 32 50 01</a>
                </span>
            </p>
            <p>
                <span class="bold">Responsable de la rédaction de la publication :</span>
                <span>Pascal PHILIPPE</span>
            </p>
            <p>
                <span class="bold">Responsable du traitement des données :</span>
                <span>Pascal PHILIPPE - <a href="mailto:pascal.philippe@jobstream.fr">pascal.philippe@jobstream.fr</a></span>
            </p>
            <p>
                <span class="bold">Réalisation du site :</span>
                <span>MEONIX, 31 Parc du Golf 13 290 Aix en Provence - <a href="mailto:contact@meonix.co">contact@meonix.co</a> - <a href="tel:0465980020">04 65 98 00 20</a></span>
            </p>
            <p>
                <span class="bold">Hébergement du site :</span>
                <span>OVH, 2 rue Kellerman 59100 Roubaix - <a href="https://help.ovhcloud.com/fr/" target="_blank">https://help.ovhcloud.com/fr/</a></span>
            </p>
            <p class="Text">
                <span class="bold">Conditions générales d'utilisation</span>
                <span>L'utilisation de ce service est réservée à un usage strictement personnel. Toute reproduction ou 
    représentation, en tout ou partie, à d'autres fins sur un quelconque support est interdite. 
    Le non-respect de cette interdiction constitue une contrefaçon pouvant engager la 
    responsabilité civile et pénale du contrefacteur. Les informations contenues dans ce service 
    sont non contractuelles et sujettes à modification sans préavis. Les caractéristiques et la 
    disponibilité des produits et services mentionnés dans ce service web sont valables 
    pour la France métropolitaine.</span>
            </p>
            <p class="Text">
                <span class="bold">Législation française</span>
                <span>Droit d'accès au fichier informatisé : tout utilisateur ayant déposé dans le service des informations 
    directement ou indirectement nominatives peut demander la communication des informations 
    nominatives le concernant à l'administrateur du service et les faire recti fier le cas échéant, 
    conformément à la loi française No 78-17 du 6 janvier 1978 relative à l'informatique, 
    aux fichiers et aux libertés.</span>
            </p>
            <p class="Text">
                <span class="bold">Données personnelles</span>
                <span>Le présent site est soumis au respect de la loi française du 6 janvier 1978, dite “Informatique et libertés”; 
    déclaration auprès de la CNIL en cours.<br><br>

    Conformément à l'article 27 de la loi du 6 janvier 1978 dite “Informatique et libertés”, 
    vous disposez d'un droit d'accès, de rectification et de suppression relatif aux données vous concernant 
    dans les conditions de l'article 34 de ladite loi.<br><br>

    Contactez-nous à l'adresse suivante : <br>
    JobStream, 230 rue Pierre Duhem  13 290 Aix en Provence, 
    en joignant à votre courrier une copie de votre carte d'identité ou de votre passeport.</span>
            </p>
            <p class="Text">
                <span class="bold">Destination des informations recueillies</span>
                <span>Les messages électroniques envoyés par l'intermédiaire des liens du présent site sont conservés 
    pour leur traitement et pendant la durée nécessaire à leur traitement. Nous nous engageons à ne 
    communiquer vos données à aucun tiers sans votre consentement préalable. Les droits d'accès 
    et de rectification s'exercent auprès de <a href="mailto:pascal.philippe@jobstream.fr">pascal.philippe@jobstream.fr</a><br><br>

    Exercice Droit d'opposition (Opt-out) Art.26 loi 1978<br><br>

    Conformément au Règlement Général sur la Protection des Données (RGPD) qui est entré en vigueur 
    le 25 mai 2018, nous nous engageons à protéger les informations personnelles que vous nous confiez.<br><br>

    Ces données sont uniquement utilisées pour vous contacter si vous avez besoin de renseignements 
    complémentaires sur nos prestations. Nous ne les communiquons pas à des tiers.</span>
            </p>
        </div>
    </div>
</template>

<script>
import HeadPageImage from '../global/HeadPageImage.vue'

export default {
    name: "MentionsLegales",
    components: {
        HeadPageImage
    }
}
</script>

<style scoped> 
/* 
*   Global
*/
.MentionsLegales-Container-Text {
    width: 70%;
    margin: auto;
    padding: 50px;
}

p, span, a {
    font-size: 14px;
    margin-bottom: 20px;
    color: black;
}

.bold {
    font-weight: bolder;
    margin: 0 10px 5px 0;
}

.Text {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
}

@media (max-width: 600px) {
    .MentionsLegales-Container-Text {
        padding: 40px;
    }
}
</style>